import { createSelector } from 'reselect';

import { authSelectors } from 'app-components/flux/auth';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

import { createAppSelector } from 'app-components/utils/core/reselect';
import type RootState from 'app-components/utils/redux-store/rootState';
import { REDUCER_KEY } from './alertRulesTypes';

type State = Pick<RootState, typeof REDUCER_KEY>;

export const getAlertRulesStore = (state: State) => state[REDUCER_KEY];
export const getLastSyncDate = (state: State) => getAlertRulesStore(state).lastSyncDate;
export const getAllAlertRules = (state: State) => getAlertRulesStore(state).resourcesById;
export const getResourceById = (state: State, id: string) => getAlertRulesStore(state).resourcesById.get(id);
export const getIsLoading = (state: State) => getAlertRulesStore(state).isLoading;

export const getAllAlertRulesSorted = createSelector(
  getAllAlertRules,
  // Any because types for feature flags / auth state dne yet
  (state: State) => featureFlagsSelectors.getFeatureFlag(state as any, 'creditReport'),
  (state: State) => authSelectors.getCurrentDataset(state as any),
  (alertRules, ffCreditReport, dataset) =>
    alertRules
      .filter(
        (alertRule) =>
          alertRule.title && //  If there is no title, do not include the rule
          (alertRule.group !== 'CREDITREPORT' || (ffCreditReport && !dataset?.shared)), // exclude all CREDITREPORT group rules if credit-report feature flag is disabled or it's a shared dataset
      )
      .sortBy(
        (alertRule) => alertRule.title!,
        (a, b) => a?.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }),
      ),
);

export const getAllAlertRuleIdsSorted = createSelector(getAllAlertRulesSorted, (alertRules) =>
  alertRules
    .valueSeq()
    .toArray()
    .map(({ id }) => id),
);

// Instead of this we could add a "fake alert rule" to act as the entity for determining pauses
export const alertRulesPaused = createAppSelector(getAllAlertRulesSorted, (alertRules) =>
  alertRules
    // If all rules in scope are disabled, then user is said to have paused notifications.
    .every((rule) => !rule.preferences.isEnabled),
);
